// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Model = require("./model");
var React = require("react");
var Apollo = require("./apollo");
var Slugify = require("./slugify");
var Decoders = require("./decoders");
var Scroller = require("./scroller");
var MaterialUI = require("bs-material-ui/lib/js/src/MaterialUI.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Shallowequal = require("shallowequal");
var Configuration = require("./configuration");
var DiscussionFull = require("./discussionFull");
var DiscussionIndex = require("./discussionIndex");
var MaterialUIIcons = require("bs-material-ui-icons/lib/js/src/MaterialUIIcons.js");
var DiscussionByGroupe = require("./discussionByGroupe");
var GraphqlSubscription = require("./graphqlSubscription");

var component = ReasonReact.reducerComponent("Discussion");

function pathToPage(path) {
  if (path) {
    switch (path[0]) {
      case "groupes" : 
          if (path[1]) {
            return /* NotFoundPage */[path];
          } else {
            return /* ByGroupePage */0;
          }
      case "tout" : 
          if (path[1]) {
            return /* NotFoundPage */[path];
          } else {
            return /* FullPage */1;
          }
      default:
        return /* NotFoundPage */[path];
    }
  } else {
    return /* IndexPage */2;
  }
}

function make(discussion, graphqlClient, hash, path, _) {
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */(function (param) {
              var state = param[/* state */2];
              if (Shallowequal(path, state[/* path */4]) && hash === state[/* hash */1]) {
                return state;
              } else {
                var page = pathToPage(path);
                return /* record */[
                        /* discussion */state[/* discussion */0],
                        /* hash */hash,
                        /* openSnackbar */state[/* openSnackbar */2],
                        /* page */page,
                        /* path */path
                      ];
              }
            }),
          /* didMount */(function (param) {
              Curry._1(param[/* send */4], /* ScrollToHash */1);
              return /* NoUpdate */0;
            }),
          /* didUpdate */(function (param) {
              return Curry._1(param[/* newSelf */1][/* send */4], /* ScrollToHash */1);
            }),
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function (self) {
              var match = self[/* state */2][/* page */3];
              var tmp;
              if (typeof match === "number") {
                switch (match) {
                  case 0 : 
                      tmp = ReasonReact.element(/* None */0, /* None */0, DiscussionByGroupe.make(self[/* state */2][/* discussion */0], (function (numero) {
                                  var hash = Curry._1(Slugify.slugify, numero);
                                  return ReasonReact.Router[/* push */0](Model.urlPathFromDiscussion(self[/* state */2][/* discussion */0]) + ("/tout#" + hash));
                                }), /* array */[]));
                      break;
                  case 1 : 
                      tmp = ReasonReact.element(/* None */0, /* None */0, DiscussionFull.make(self[/* state */2][/* discussion */0], (function (numero) {
                                  var hash = Curry._1(Slugify.slugify, numero);
                                  return ReasonReact.Router[/* push */0](Model.urlPathFromDiscussion(self[/* state */2][/* discussion */0]) + ("/tout#" + hash));
                                }), /* array */[]));
                      break;
                  case 2 : 
                      tmp = ReasonReact.element(/* None */0, /* None */0, DiscussionIndex.make(self[/* state */2][/* discussion */0], (function (numero) {
                                  var hash = Curry._1(Slugify.slugify, numero);
                                  return ReasonReact.Router[/* push */0](Model.urlPathFromDiscussion(self[/* state */2][/* discussion */0]) + ("/tout#" + hash));
                                }), /* array */[]));
                      break;
                  
                }
              } else {
                tmp = React.createElement("div", undefined, ReasonReact.element(/* None */0, /* None */0, MaterialUI.AppBar[/* make */0](/* Some */["static"], /* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Toolbar[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Title */5], /* array */[Model.ste(Configuration.config[/* appTitle */1])]))]))])), React.createElement("p", undefined, Model.ste("Page not foud!")));
              }
              var discussion = self[/* state */2][/* discussion */0];
              var match$1 = discussion[/* numeroProchainADiscuter */5];
              var match$2 = self[/* state */2][/* openSnackbar */2];
              var tmp$1;
              if (match$1) {
                if (match$2 !== 0) {
                  var numeroProchainADiscuter = match$1[0];
                  var hash = Curry._1(Slugify.slugify, numeroProchainADiscuter);
                  var amendementUrlPath = Model.urlPathFromDiscussion(discussion) + ("/tout#" + hash);
                  tmp$1 = ReasonReact.element(/* None */0, /* None */0, MaterialUI.Snackbar[/* make */0](/* Some */[React.createElement("span", undefined, ReasonReact.element(/* None */0, /* None */0, MaterialUI.Button[/* make */3](/* None */0, /* None */0, /* None */0, /* Some */[/* Secondary */3], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[amendementUrlPath], /* None */0, /* Some */[(function ($$event) {
                                              $$event.preventDefault();
                                              $$event.stopPropagation();
                                              ReasonReact.Router[/* push */0](amendementUrlPath);
                                              return Curry._1(self[/* send */4], /* CloseSnackbar */0);
                                            })], /* Some */[/* Small */2], /* None */0, /* None */0, /* None */0, /* array */[Model.ste("VOIR")])), ReasonReact.element(/* None */0, /* None */0, MaterialUI.IconButton[/* make */1](/* None */0, /* None */0, /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[(function () {
                                              return Curry._1(self[/* send */4], /* CloseSnackbar */0);
                                            })], /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUIIcons.Close[/* make */0](/* array */[]))])))], /* Some */[6000], /* None */0, /* Some */[React.createElement("span", undefined, Model.ste("Amendement " + (numeroProchainADiscuter + " en discussion !")))], /* Some */[(function (_, _$1) {
                                return Curry._1(self[/* send */4], /* CloseSnackbar */0);
                              })], /* Some */[/* true */1], /* None */0, /* None */0, /* array */[]));
                } else {
                  tmp$1 = null;
                }
              } else {
                tmp$1 = null;
              }
              return React.createElement("div", undefined, tmp, tmp$1);
            }),
          /* initialState */(function () {
              return /* record */[
                      /* discussion */discussion,
                      /* hash */hash,
                      /* openSnackbar : false */0,
                      /* page */pathToPage(path),
                      /* path */path
                    ];
            }),
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */(function (action, state) {
              if (typeof action === "number") {
                if (action) {
                  var match = +(state[/* hash */1] === "");
                  if (match !== 0) {
                    return /* NoUpdate */0;
                  } else {
                    return /* SideEffects */Block.__(2, [(function () {
                                  return Curry._1(Scroller.scrollToId, state[/* hash */1]);
                                })]);
                  }
                } else {
                  return /* Update */Block.__(0, [/* record */[
                              /* discussion */state[/* discussion */0],
                              /* hash */state[/* hash */1],
                              /* openSnackbar : false */0,
                              /* page */state[/* page */3],
                              /* path */state[/* path */4]
                            ]]);
                }
              } else if (action.tag) {
                var discussion = state[/* discussion */0];
                var prochainADiscuter = Decoders.prochainADiscuterUpsertedWrapper(action[0]);
                if (prochainADiscuter[/* bibard */0] === discussion[/* bibard */1] && prochainADiscuter[/* bibardSuffixe */1] === discussion[/* bibardSuffixe */2] && prochainADiscuter[/* legislature */2] === discussion[/* legislature */4] && prochainADiscuter[/* organeAbrv */5] === discussion[/* organe */6]) {
                  var newrecord = discussion.slice();
                  return /* Update */Block.__(0, [/* record */[
                              /* discussion */(newrecord[/* numeroProchainADiscuter */5] = /* Some */[prochainADiscuter[/* numAmdt */4]], newrecord),
                              /* hash */state[/* hash */1],
                              /* openSnackbar : true */1,
                              /* page */state[/* page */3],
                              /* path */state[/* path */4]
                            ]]);
                } else {
                  return /* NoUpdate */0;
                }
              } else {
                var discussion$1 = state[/* discussion */0];
                var amendement = Decoders.amendementUpsertedWrapper(action[0]);
                if (amendement[/* bibard */1] === discussion$1[/* bibard */1] && amendement[/* bibardSuffixe */2] === discussion$1[/* bibardSuffixe */2] && amendement[/* legislature */8] === discussion$1[/* legislature */4] && amendement[/* organeAbrv */12] === discussion$1[/* organe */6]) {
                  var amendementsWrappers = $$Array.map((function (amendementWrapper) {
                          if (amendementWrapper[/* numero */11] === amendement[/* numeroReference */11]) {
                            var newrecord = amendementWrapper.slice();
                            newrecord[/* amendement */1] = /* Some */[amendement];
                            newrecord[/* sort */15] = amendement[/* sortEnSeance */15];
                            return newrecord;
                          } else {
                            return amendementWrapper;
                          }
                        }), discussion$1[/* amendements */0]);
                  var newrecord$1 = discussion$1.slice();
                  return /* Update */Block.__(0, [/* record */[
                              /* discussion */(newrecord$1[/* amendements */0] = amendementsWrappers, newrecord$1),
                              /* hash */state[/* hash */1],
                              /* openSnackbar */state[/* openSnackbar */2],
                              /* page */state[/* page */3],
                              /* path */state[/* path */4]
                            ]]);
                } else {
                  return /* NoUpdate */0;
                }
              }
            }),
          /* subscriptions */(function (self) {
              return /* :: */[
                      /* Sub */[
                        (function () {
                            return GraphqlSubscription.subscribe(graphqlClient, Curry._1(Apollo.createAmendementUpsertedSubscriptionQuery, /* () */0), (function (data) {
                                          return Curry._1(self[/* send */4], /* GotAmendement */Block.__(0, [data]));
                                        }));
                          }),
                        GraphqlSubscription.unsubscribe
                      ],
                      /* :: */[
                        /* Sub */[
                          (function () {
                              return GraphqlSubscription.subscribe(graphqlClient, Curry._1(Apollo.createProchainADiscuterUpsertedSubscriptionQuery, /* () */0), (function (data) {
                                            return Curry._1(self[/* send */4], /* GotProchainADiscuter */Block.__(1, [data]));
                                          }));
                            }),
                          GraphqlSubscription.unsubscribe
                        ],
                        /* [] */0
                      ]
                    ];
            }),
          /* jsElementWrapped */component[/* jsElementWrapped */14]
        ];
}

exports.component = component;
exports.pathToPage = pathToPage;
exports.make = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/discussion.re
// module id = 1661
// module chunks = 0